import { useEffect, useState } from "react"

/**
 * Hook that debounces a value by delaying its update
 * @param value - The value to debounce
 * @param delay - Delay in milliseconds (default: 500ms)
 * @returns The debounced value
 */
export function useDebounce<T>(value: T, delay: number = 500): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    // Set up the timeout to update debounced value after delay
    const timer = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    // Cleanup function: clear timeout if value changes before delay expires
    // This ensures only the last value gets set after user stops typing
    return () => {
      clearTimeout(timer)
    }
  }, [value, delay]) // Re-run effect when value or delay changes

  return debouncedValue
}
